import { useTranslation } from 'react-i18next';

import { PrimaryButton } from '@/components/common/Button/style';
import Textarea from '@/components/common/Input/Textarea/Textarea';
import { privacyText, termsText } from '@/constants/terms';
import { useModalStore } from '@/store/modalStore';

import * as S from './style';
import { useSignUpStore } from '../SignUpContext/SignUpContext';

interface TermsProps {
	serviceAgree: boolean;
	privacyAgree: boolean;
	handleServiceAgree: (bool: boolean) => void;
	handlePrivacyAgree: (bool: boolean) => void;
}

const Terms = ({ serviceAgree, privacyAgree, handlePrivacyAgree, handleServiceAgree }: TermsProps) => {
	const { t } = useTranslation();
	const { showModal } = useModalStore();
	const { setStep, setCurrentStep } = useSignUpStore();

	const handleNext = () => {
		if (serviceAgree && privacyAgree) {
			setStep('기본정보 입력');
			setCurrentStep('기본정보 입력');
		} else {
			showModal(t('signup.terms.alerts.agreeAll'));
		}
	};

	return (
		<S.FieldBox>
			<S.TermsGrid>
				<S.AgreementCard>
					<S.AgreementTitle>{t('signup.terms.fields.serviceTitle')}</S.AgreementTitle>
					<S.TermsScroll>
						<Textarea value={t(termsText)} />
					</S.TermsScroll>
					<S.AgreeRow>
						<input
							type="checkbox"
							id="signup-service-agree"
							checked={serviceAgree}
							onChange={() => handleServiceAgree(!serviceAgree)}
						/>
						{t('signup.terms.fields.serviceAgree')}
					</S.AgreeRow>
				</S.AgreementCard>

				<S.AgreementCard>
					<S.AgreementTitle>{t('signup.terms.fields.privacyTitle')}</S.AgreementTitle>
					<S.TermsScroll>
						<Textarea value={t(privacyText)} />
					</S.TermsScroll>
					<S.AgreeRow>
						<input
							type="checkbox"
							id="signup-privacy-agree"
							checked={privacyAgree}
							onChange={() => handlePrivacyAgree(!privacyAgree)}
						/>
						{t('signup.terms.fields.privacyAgree')}
					</S.AgreeRow>
				</S.AgreementCard>
			</S.TermsGrid>

			<S.Actions>
				<PrimaryButton type="button" disabled={!serviceAgree || !privacyAgree} onClick={handleNext} $fullWidth>
					{t('common.actions.next')}
				</PrimaryButton>
			</S.Actions>
		</S.FieldBox>
	);
};

export default Terms;
